/**
 * Config file that describes all of our api routes
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */

export default {
  apiUrl: '/api/v1',
  batch: {
    url: '/batch',
    delete: '/delete'
  },
  quizzes: {
    url: '/quizzes',
    personality: '/personality'
  },
  users: {
    url: '/users',
    signup: '/signup',
    personality: '/personality',
    username: '/username',
    profile: {
      url: '/profile',
      uploadPhoto: '/photoUpload',
      deletePhoto: '/photoDelete'
    },
    settings: {
      url: '/settings',
      account: '/account'
    },
    feeds: {
      url: '/feeds',
      tokens: '/tokens',
      notification: '/notification'
    }
  },
  boards: {
    url: '/boards',
    lists: '/lists',
    places: '/places',
    notes: '/notes',
    public: '/public',
    upload: '/upload',
    delete: '/delete',
    settings: '/settings',
    order: '/order',
    search: '/search',
    authorized: '/authorized',
    reorderPlaces: '/reorderPlaces',
    collaborators: '/collaborators',
    invites: '/invites',
    resend: '/resend',
    copy: '/copy',
    tags: {
      url: '/tags',
      delete: '/delete'
    },
    photos: {
      url: '/photos',
      backgroundPhoto: '/backgroundPhoto',
      placePhotos: '/placePhotos'
    }
  },
  hotels: {
    url: '/hotels',
    bookings: '/bookings',
    pricings: '/pricings'
  },
  follows: {
    url: '/follows',
    follow: '/follow',
    unfollow: '/unfollow',
    approve: '/approve'
  },
  places: {
    url: '/places',
    details: '/details'
  },
  explore: {
    url: '/explore',
    boards: {
      url: '/boards',
      staycations: '/staycations',
      popular: '/popular'
    },
    hotels: {
      url: '/hotels',
      popular: '/popular'
    },
    destinations: {
      url: '/destinations'
    },
    popular: {
      url: '/popular'
    }
  },
  announcements: {
    url: '/announcements'
  },
  featureFlags: {
    url: '/featureFlags'
  },
  usernames: {
    url: '/usernames'
  },
  search: {
    url: '/search',
    users: '/users'
  },
  sitemap: {
    url: '/sitemap',
    locations: {
      url: '/locations',
      boards: '/boards'
    }
  },
  suggestions: {
    url: '/suggestions'
  },
  websockets: {
    path: '/api/ws',
    namespaces: {
      board: '/board'
    }
  }
}
